import 'modernizr'; // eslint-disable-line
import '../vendor/bootstrap';

import Accessibility from '../modules/accessibility';
import Tracking from '../modules/tracking';
import FormValidation from '../modules/formValidation';
import navigation from '../modules/navigation';
import toTop from '../modules/toTop';
import videoElement from '../modules/videoElement';
import slider from '../modules/slider';
import sliderThumbs from '../modules/sliderThumbs';
import toggle from '../modules/toggle';
import orderForm from '../modules/orderForm';
import jumpToElement from '../modules/jumpToElement';
import cart from '../modules/cart';
import datepicker from '../modules/datepicker';
import embedWrap from '../modules/embedWrap';
import productItem from '../modules/productItem';
import alert from '../modules/alert';
import cartSummary from '../modules/cartSummary';
import map from '../modules/maps/map';
import filter from '../modules/filter/filter';
import searchComplete from '../modules/searchComplete';
import headerSearch from '../modules/headerSearch';
import alertBanner from '../modules/alertBanner';
// insert-import

const general = () => {
  window.app.tracking = new Tracking(window.app);
  window.app.accessibility = new Accessibility(window.app);
  window.app.formValidation = new FormValidation();
  navigation.initialize();
  toTop.initialize();
  videoElement.initialize();
  slider.initialize();
  sliderThumbs.initialize();
  toggle.initialize();
  orderForm.initialize();
  jumpToElement.initialize();
  cart.initialize();
  datepicker.initialize();
  embedWrap();
  productItem.initialize();
  alert.initialize();
  cartSummary.initialize();
  map.initialize();
  filter.initialize();
  searchComplete.initialize();
  headerSearch.initialize();
  alertBanner.initialize();
  // insert-definition
};

export default general;
